export const en: Record<string, string> = {
  // Sidebar
  "nav.home": "Dashboard",
  "nav.assistant": "Legal Assistant",
  "nav.legalMemo": "Legal Memos",
  "nav.documentAnalysis": "Document Analysis",
  "nav.smartSearch": "Smart Search",
  "nav.contractAnalysis": "Contract Analysis",
  "nav.analysisHub": "Document Analysis",
  "analysisHub.title": "Documents & Contracts Analysis",
  "analysisHub.subtitle": "AI-powered analysis for legal documents and contracts",
  "analysisHub.documentsTab": "Document Analysis",
  "analysisHub.contractsTab": "Contract Analysis",
  "nav.smartInterrogation": "Smart Interrogation",
  "nav.calendar": "Calendar",
  "nav.sessions": "Sessions",
  "nav.clients": "Clients",
  "nav.tasks": "Tasks",
  "nav.teamTasks": "Team Tasks",
  "nav.teamPerformance": "Team Performance",
  "nav.files": "Files",
  "nav.announcements": "Announcements",
  "nav.cases": "Cases",
  "nav.records": "Bailiff Agenda",
  "nav.archive": "Archive",
  "nav.notifications": "Notifications",
  "nav.finances": "Finance & Time",
  "nav.clientIntake": "Client Intake",
  "nav.report": "System Report",
  "nav.subscribedOffices": "Subscribed Offices",
  "nav.backup": "Backup & Export",
  "nav.caseRoll": "Case Roll",
  "sidebar.system": "Law Practice Management",
  "sidebar.changePassword": "Change Password",
  "sidebar.newPassword": "New Password",
  "sidebar.confirmPassword": "Confirm Password",
  "sidebar.enterNewPassword": "Enter new password",
  "sidebar.reenterPassword": "Re-enter password",
  "sidebar.updating": "Updating...",
  "sidebar.updatePassword": "Update Password",
  "sidebar.ai": "AI Tools",
  "sidebar.management": "Office Management",
  "sidebar.more": "More",

  // Common
  "common.add": "Add",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.search": "Search",
  "common.loading": "Loading...",
  "common.noData": "No data",
  "common.error": "Error",
  "common.success": "Success",
  "common.copy": "Copy",
  "common.download": "Download",
  "common.copied": "Copied",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.back": "Back",
  "common.next": "Next",
  "common.previous": "Previous",
  "common.all": "All",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "common.now": "Now",
  "common.view": "View",
  "common.print": "Print",
  "common.export": "Export",

  // Dashboard
  "dashboard.title": "Dashboard",
  "dashboard.welcome": "Welcome to Legal AI",
  "dashboard.activeCases": "Active Cases",
  "dashboard.clients": "Clients",
  "dashboard.pendingTasks": "Pending Tasks",
  "dashboard.files": "Files",
  "dashboard.upcomingEvents": "Upcoming Events",
  "dashboard.noUpcomingEvents": "No upcoming events",
  "dashboard.addEventsFromCalendar": "Add events from the Calendar page",
  "dashboard.latestNotifications": "Latest Notifications",
  "dashboard.noNotifications": "No notifications",
  "dashboard.enableNotifications": "Enable Push Notifications",
  "dashboard.enableNotificationsDesc": "Get automatic alerts before session dates",
  "dashboard.enable": "Enable",
  "dashboard.notificationsEnabled": "Notifications enabled — you'll get alerts before sessions",
  "dashboard.pendingTasksNotif": "Pending Tasks",
  "dashboard.upcomingAppointments": "Upcoming Appointments",
  "dashboard.activeCasesNotif": "Active Cases",

  // Cases
  "cases.title": "Cases",
  "cases.subtitle": "Manage and track cases",
  "cases.newCase": "New Case",
  "cases.editCase": "Edit Case",
  "cases.addCase": "Add New Case",
  "cases.caseNumber": "Case Number",
  "cases.caseTitle": "Case Subject",
  "cases.selectClient": "Select Client",
  "cases.caseType": "Case Type",
  "cases.court": "Court",
  "cases.clientDetails": "Client Details (visible to client)",
  "cases.status.active": "Active",
  "cases.status.pending": "Pending",
  "cases.status.closed": "Closed",
  "cases.assignToMember": "Assign to team member (optional)",
  "cases.saveChanges": "Save Changes",
  "cases.searchPlaceholder": "Search by case number or client name...",
  "cases.noCases": "No cases found",
  "cases.noCasesHint": "Click \"New Case\" to add a case",
  "cases.documents": "Documents",
  "cases.prediction": "Predict Outcome",
  "cases.caseNumberLabel": "Case No:",

  // Sessions
  "sessions.title": "Sessions",
  "sessions.subtitle": "Track all court sessions with reminders",
  "sessions.addSession": "Add Session",
  "sessions.editSession": "Edit Session",
  "sessions.addNewSession": "Add New Session",
  "sessions.upcoming": "Upcoming Sessions",
  "sessions.past": "Past Sessions",
  "sessions.noUpcoming": "No upcoming sessions",
  "sessions.caseNumber": "Case Number",
  "sessions.caseTitle": "Case Title",
  "sessions.court": "Court",
  "sessions.selectCourt": "Select Court",
  "sessions.roomNumber": "Circuit Number",
  "sessions.sessionDate": "Session Date",
  "sessions.selectDate": "Select Date",
  "sessions.sessionTime": "Session Time",
  "sessions.reminderBefore": "Remind before (days)",
  "sessions.notes": "Notes",
  "sessions.additionalNotes": "Additional notes...",
  "sessions.ended": "Ended",
  "sessions.today": "Today",
  "sessions.tomorrow": "Tomorrow",
  "sessions.daysLeft": "In {days} days",
  "sessions.oneDay": "1 day",
  "sessions.twoDays": "2 days",
  "sessions.threeDays": "3 days",
  "sessions.oneWeek": "1 week",
  "sessions.other": "Other",
  "sessions.enterCourtName": "Enter court name",
  "sessions.roomExample": "e.g. Circuit 5",
  "sessions.morning": "Morning",
  "sessions.evening": "Evening",
  "sessions.selectTime": "Select session time",
  "sessions.number": "No:",

  // Clients
  "clients.title": "Clients",
  "clients.subtitle": "Manage client data",
  "clients.addClient": "Add Client",
  "clients.addNewClient": "Add New Client",
  "clients.clientName": "Client Name",
  "clients.phone": "Phone Number",
  "clients.email": "Email",
  "clients.casesCount": "Cases Count",
  "clients.searchPlaceholder": "Search by name or phone...",
  "clients.noClients": "No clients",
  "clients.noClientsHint": "Click \"Add Client\" to add a new client",
  "clients.viewProfile": "View Client Profile",

  // Tasks
  "tasks.title": "Tasks",
  "tasks.subtitle": "Manage and track daily tasks",
  "tasks.addTask": "Add Task",
  "tasks.editTask": "Edit Task",
  "tasks.addNewTask": "Add New Task",
  "tasks.taskTitle": "Task Title",
  "tasks.taskDescription": "Task Description",
  "tasks.dueDate": "Due Date",
  "tasks.caseNumber": "Case Number (optional)",
  "tasks.priority": "Priority",
  "tasks.priority.high": "Urgent",
  "tasks.priority.medium": "Medium",
  "tasks.priority.low": "Low",
  "tasks.pending": "Pending Tasks",
  "tasks.urgent": "Urgent Tasks",
  "tasks.completed": "Completed Tasks",
  "tasks.pendingTasks": "Pending Tasks",
  "tasks.completedTasks": "Completed Tasks",
  "tasks.noPending": "No pending tasks",
  "tasks.noCompleted": "No completed tasks",

  // Calendar
  "calendar.title": "Calendar",
  "calendar.subtitle": "Manage appointments and sessions",
  "calendar.addEvent": "Add Event",
  "calendar.addNewEvent": "Add New Event",
  "calendar.eventTitle": "Event Title",
  "calendar.eventTime": "Time (e.g. 10:00 AM)",
  "calendar.eventType": "Event Type",
  "calendar.selectedDate": "Selected date:",
  "calendar.type.court": "Court Session",
  "calendar.type.meeting": "Meeting",
  "calendar.type.task": "Task",
  "calendar.eventsFor": "Events for",
  "calendar.noEvents": "No events for this day",
  "calendar.noEventsHint": "Click \"Add Event\" to add a new event",
  "calendar.typeLabels.court": "Session",
  "calendar.typeLabels.meeting": "Meeting",
  "calendar.typeLabels.task": "Task",

  // Files
  "files.title": "Files",
  "files.subtitle": "Manage and organize files and documents",
  "files.upload": "Upload File",
  "files.uploading": "Uploading...",
  "files.searchPlaceholder": "Search files...",
  "files.allFiles": "Files",
  "files.noFiles": "No files",
  "files.noFilesHint": "Click \"Upload File\" to add files",

  // Announcements
  "announcements.title": "Announcements",
  "announcements.subtitle": "Latest news and announcements",
  "announcements.newAnnouncement": "New Announcement",
  "announcements.addNew": "Add New Announcement",
  "announcements.announcementTitle": "Announcement Title",
  "announcements.announcementContent": "Announcement Content",
  "announcements.pinAnnouncement": "Pin Announcement",
  "announcements.noAnnouncements": "No announcements",
  "announcements.noAnnouncementsHint": "Click \"New Announcement\" to add one",
  "announcements.author": "Lawyer",

  // Records (Bailiff Agenda)
  "records.title": "Bailiff Agenda",
  "records.subtitle": "Manage bailiff tasks and judicial notifications",
  "records.newRecord": "New Entry",
  "records.addNew": "Add New Agenda Entry",
  "records.recordTitle": "Subject / Action",
  "records.caseNumber": "Case Number",
  "records.recordType": "Action Type",
  "records.date": "Execution Date",
  "records.searchPlaceholder": "Search agenda...",
  "records.allRecords": "Agenda Log",
  "records.noRecords": "No entries in the agenda",
  "records.noRecordsHint": "Click \"New Entry\" to start logging",
  "records.partyName": "Party Name",
  "records.address": "Address",
  "records.status": "Status",
  "records.statusPending": "Pending",
  "records.statusDone": "Executed",
  "records.statusFailed": "Failed",

  // Archive
  "archive.title": "Archive",
  "archive.subtitle": "Archived cases and files",
  "archive.totalArchived": "Total Archived",
  "archive.folders": "Folders",
  "archive.closedCases": "Closed Cases",
  "archive.searchPlaceholder": "Search archive...",
  "archive.archivedItems": "Archived Items",
  "archive.archiveDate": "Archive date:",
  "archive.noItems": "No archived items",
  "archive.noItemsHint": "Archived cases and files will appear here",

  // Notifications
  "notifications.title": "Notifications",
  "notifications.newNotifications": "You have {count} new notifications",
  "notifications.noNewNotifications": "No new notifications",
  "notifications.markAllRead": "Mark all as read",
  "notifications.addNotification": "Add Notification",
  "notifications.addNew": "Add New Notification",
  "notifications.notificationTitle": "Notification Title",
  "notifications.notificationText": "Notification Text",
  "notifications.notificationType": "Notification Type",
  "notifications.type.reminder": "Reminder",
  "notifications.type.case": "Case",
  "notifications.type.file": "File",
  "notifications.type.message": "Message",
  "notifications.markRead": "Mark as read",
  "notifications.allNotifications": "All Notifications",
  "notifications.noNotifications": "No notifications",
  "notifications.noNotificationsHint": "Add new notifications using the add button",

  // Assistant
  "assistant.title": "Smart Legal Assistant",
  "assistant.subtitle": "Ask any legal question and get an instant answer",
  "assistant.welcome": "Welcome to the Legal Assistant",
  "assistant.welcomeDesc": "I'm here to help with legal inquiries. Choose a quick question or type your own",
  "assistant.placeholder": "Type your legal question here or press the microphone...",
  "assistant.q1": "What are the procedures for filing a civil lawsuit?",
  "assistant.q2": "How do I write a legal lease agreement?",
  "assistant.q3": "What are my rights in labor cases?",
  "assistant.q4": "Procedures for establishing a new company",

  // Legal Memo
  "legalMemo.title": "Legal Memo Drafting",
  "legalMemo.subtitle": "Use AI to draft legal memos and documents",
  "legalMemo.details": "Memo Details",
  "legalMemo.memoType": "Memo Type",
  "legalMemo.selectType": "Select memo type...",
  "legalMemo.caseDetails": "Case Details",
  "legalMemo.caseDetailsPlaceholder": "Write case details here... e.g. case type, parties, facts, requests...",
  "legalMemo.generate": "Draft Memo",
  "legalMemo.generating": "Drafting...",
  "legalMemo.memo": "Memo",
  "legalMemo.regenerate": "Redo",
  "legalMemo.emptyHint": "Select memo type and write case details then click \"Draft Memo\"",
  "legalMemo.type.defense": "Defense Memo",
  "legalMemo.type.appeal": "Appeal Memo",
  "legalMemo.type.cassation": "Cassation Memo",
  "legalMemo.type.reply": "Reply Memo",
  "legalMemo.type.closing": "Closing Memo",
  "legalMemo.type.complaint": "Complaint",
  "legalMemo.type.contract": "Legal Contract",

  // Document Analysis
  "docAnalysis.title": "AI Document Analysis",
  "docAnalysis.subtitle": "Upload or paste a legal document for comprehensive analysis",
  "docAnalysis.document": "Document",
  "docAnalysis.uploadFile": "Upload Text File",
  "docAnalysis.pastePlaceholder": "Paste legal document text here... (contract, ruling, memo, complaint, etc.)",
  "docAnalysis.analyze": "Analyze Document",
  "docAnalysis.analyzing": "Analyzing...",
  "docAnalysis.result": "Analysis Result",
  "docAnalysis.analyzingAI": "Analyzing document with AI...",
  "docAnalysis.emptyHint": "Paste the document and click \"Analyze\" to see results",

  // Smart Search
  "smartSearch.title": "Smart Case Search",
  "smartSearch.subtitle": "Search all your data using natural language",
  "smartSearch.search": "Search",
  "smartSearch.placeholder": "Type what you're looking for... e.g. Show me all rental cases",
  "smartSearch.results": "Search Results",
  "smartSearch.searching": "Searching with AI...",
  "smartSearch.emptyHint": "Type your query and click search to see results",

  // Contract Analysis
  "contractAnalysis.title": "Contract Analysis",
  "contractAnalysis.subtitle": "Analyze contracts and extract risks and recommendations with AI",
  "contractAnalysis.contractText": "Contract Text",
  "contractAnalysis.contractType": "Contract Type (optional)",
  "contractAnalysis.selectType": "Select contract type",
  "contractAnalysis.uploadFile": "Upload File (PDF, Word, Text)",
  "contractAnalysis.pastePlaceholder": "Paste contract text here... or upload a PDF / Word file",
  "contractAnalysis.analyze": "Analyze Contract",
  "contractAnalysis.analyzing": "Analyzing...",
  "contractAnalysis.result": "Analysis Result",
  "contractAnalysis.analyzingAI": "Analyzing contract with AI...",
  "contractAnalysis.emptyHint": "Paste contract text or upload a file and click \"Analyze\" to see results",
  "contractAnalysis.fileAnalysis": "File will be analyzed directly with AI",
  "contractAnalysis.removeForManual": "Or remove the file to paste text manually",

  // Smart Interrogation
  "interrogation.title": "Smart Interrogation",
  "interrogation.subtitle": "Generate professional interrogation questions with AI",
  "interrogation.caseData": "Case Data",
  "interrogation.caseType": "Case Type",
  "interrogation.selectCaseType": "Select case type",
  "interrogation.caseDetails": "Case Details",
  "interrogation.caseDetailsPlaceholder": "Write case details and key facts...",
  "interrogation.evidence": "Available Evidence (optional)",
  "interrogation.evidencePlaceholder": "List available evidence and documents...",
  "interrogation.targetPerson": "Target Person (optional)",
  "interrogation.targetPlaceholder": "e.g. Defendant, Witness, Respondent",
  "interrogation.generate": "Generate Questions",
  "interrogation.generating": "Generating...",
  "interrogation.questions": "Interrogation Questions",
  "interrogation.generatingAI": "Generating interrogation questions...",
  "interrogation.emptyHint": "Enter case data to generate interrogation questions",

  // Finances
  "finances.title": "Financial Reports & Time Tracking",
  "finances.subtitle": "Manage revenue, expenses, and log work hours",
  "finances.financialReports": "Financial Reports",
  "finances.timeTracking": "Time Tracking",

  // Client Intake
  "intake.title": "Client Intake",
  "intake.subtitle": "Manage new client requests",
  "intake.addNewClient": "Add New Client",
  "intake.total": "Total",
  "intake.new": "New",
  "intake.reviewed": "Reviewed",
  "intake.converted": "Converted",
  "intake.rejected": "Rejected",
  "intake.fullName": "Full Name",
  "intake.phone": "Phone Number",
  "intake.email": "Email",
  "intake.caseType": "Case Type",
  "intake.caseDescription": "Case Description",
  "intake.caseDescPlaceholder": "Briefly describe the case...",
  "intake.preferredDate": "Preferred Contact Date",
  "intake.addClient": "Add Client",
  "intake.adding": "Adding...",
  "intake.noRequests": "No requests",
  "intake.name": "Name",
  "intake.status": "Status",
  "intake.dateCol": "Date",
  "intake.actions": "Actions",
  "intake.viewDetails": "View Details",
  "intake.convertToClient": "Convert to Client",
  "intake.requestDetails": "Request Details",
  "intake.notSpecified": "Not specified",
  "intake.noDescription": "None",

  // Report
  "report.title": "System Report",
  "report.subtitle": "Comprehensive report of all system features",
  "report.print": "Print Report",
  "report.about": "About the System",

  // Team Tasks
  "teamTasks.title": "Team Tasks",
  "teamTasks.subtitle": "Manage and distribute tasks to the team",
  "teamTasks.addMember": "Add Member",
  "teamTasks.addNewMember": "Add New Team Member",
  "teamTasks.memberName": "Member Name",
  "teamTasks.memberEmail": "Email",
  "teamTasks.distributeTask": "Assign Task",
  "teamTasks.distributeNewTask": "Assign New Task",
  "teamTasks.taskTitle": "Task Title",
  "teamTasks.taskDescription": "Task Description",
  "teamTasks.selectAssignee": "Select assignee",
  "teamTasks.distributeBtn": "Assign Task",
  "teamTasks.filterByMember": "Filter by member:",
  "teamTasks.allMembers": "All Members",
  "teamTasks.tasksTab": "Tasks",
  "teamTasks.membersTab": "Team",
  "teamTasks.pendingTasks": "Pending Tasks",
  "teamTasks.completedTasks": "Completed Tasks",
  "teamTasks.teamMembers": "Team Members",
  "teamTasks.noPending": "No pending tasks",
  "teamTasks.noCompleted": "No completed tasks",

  // Team Performance
  "teamPerformance.title": "Team Performance",
  "teamPerformance.subtitle": "Track lawyer progress and performance",
  "teamPerformance.teamMembers": "Team Members",
  "teamPerformance.completedTasks": "Completed Tasks",
  "teamPerformance.assignedCases": "Assigned Cases",
  "teamPerformance.avgCompletion": "Avg Completion",
  "teamPerformance.overdueTasks": "overdue task(s) need attention",
  "teamPerformance.noMembers": "No team members",
  "teamPerformance.noMembersHint": "Add members from \"Team Tasks\" page first",
  "teamPerformance.completionRate": "Completion Rate",
  "teamPerformance.completed": "Completed",
  "teamPerformance.inProgress": "In Progress",
  "teamPerformance.overdue": "Overdue",
  "teamPerformance.activeCases": "active case(s)",
  "teamPerformance.closedCases": "Closed",

  // Subscribed Offices
  "offices.title": "Subscribed Offices",
  "offices.subtitle": "Track and manage office subscriptions",
  "offices.addOffice": "Add Office",
  "offices.editOffice": "Edit Office",
  "offices.addNewOffice": "Add New Office",
  "offices.totalOffices": "Total Offices",
  "offices.activeSubscription": "Active Subscriptions",
  "offices.totalUsers": "Total Users",
  "offices.totalRevenue": "Total Revenue",
  "offices.officeName": "Office Name",
  "offices.contactPerson": "Contact Person",
  "offices.plan": "Plan",
  "offices.amount": "Amount",
  "offices.users": "Users",
  "offices.expiresOn": "Expires On",
  "offices.status": "Status",
  "offices.status.active": "Active",
  "offices.status.expired": "Expired",
  "offices.status.trial": "Trial",
  "offices.planType": "Plan Type",
  "offices.plan.monthly": "Monthly",
  "offices.plan.quarterly": "Quarterly",
  "offices.plan.semiAnnual": "Semi-Annual",
  "offices.plan.annual": "Annual",
  "offices.subscriptionStart": "Subscription Start",
  "offices.subscriptionEnd": "Subscription End",
  "offices.maxUsers": "Max Users",
  "offices.address": "Address",
  "offices.notes": "Notes",
  "offices.confirmDelete": "Confirm Delete",
  "offices.deleteConfirmMsg": "Are you sure you want to delete this office?",
  "offices.update": "Update",
  "offices.noOffices": "No offices registered yet",
  "offices.expiringWarning": "{count} office(s) subscription expiring within 7 days:",

  // Toast messages
  "toast.added": "Added",
  "toast.edited": "Edited",
  "toast.deleted": "Deleted",
  "toast.saved": "Saved",
  "toast.error": "Error",
  "toast.fillRequired": "Please fill in required fields",
  "toast.fillAll": "Please fill in all fields",
  "toast.passwordShort": "Password must be at least 8 characters",
  "toast.passwordMismatch": "Passwords don't match",
  "toast.passwordUpdated": "Password changed successfully",
  "toast.passwordFailed": "Failed to update password",

  // Courts
  "court.partial": "Partial Court",
  "court.primary": "Primary Court",
  "court.appeal": "Court of Appeal",
  "court.cassation": "Court of Cassation",
  "court.administrative": "Administrative Court",
  "court.family": "Family Court",
  "court.criminal": "Criminal Court",
  "court.commercial": "Commercial Court",
  "court.other": "Other",

  // Case types for interrogation
  "caseType.criminal": "Criminal",
  "caseType.civil": "Civil",
  "caseType.commercial": "Commercial",
  "caseType.labor": "Labor",
  "caseType.personalStatus": "Personal Status",
  "caseType.administrative": "Administrative",
  "caseType.rental": "Rental",
  "caseType.inheritance": "Inheritance",

  // Case Detail
  "caseDetail.loading": "Loading...",
  "caseDetail.caseNumber": "No:",
  "caseDetail.upcomingSessions": "Upcoming Sessions",
  "caseDetail.pendingTasks": "Pending Tasks",
  "caseDetail.documents": "Documents",
  "caseDetail.netFinance": "Net Finance",
  "caseDetail.sessions": "Sessions",
  "caseDetail.tasks": "Tasks",
  "caseDetail.documentsTab": "Documents",
  "caseDetail.finances": "Finances",
  "caseDetail.addSession": "Add Session",
  "caseDetail.addNewSession": "Add New Session",
  "caseDetail.court": "Court *",
  "caseDetail.room": "Room",
  "caseDetail.roomPlaceholder": "Room Number",
  "caseDetail.date": "Date *",
  "caseDetail.time": "Time *",
  "caseDetail.reminderBefore": "Remind before",
  "caseDetail.oneDay": "1 day",
  "caseDetail.twoDays": "2 days",
  "caseDetail.threeDays": "3 days",
  "caseDetail.oneWeek": "1 week",
  "caseDetail.notes": "Notes",
  "caseDetail.notesPlaceholder": "Notes...",
  "caseDetail.addSessionBtn": "Add Session",
  "caseDetail.noSessions": "No sessions",
  "caseDetail.ended": "Ended",
  "caseDetail.today": "Today",
  "caseDetail.tomorrow": "Tomorrow",
  "caseDetail.daysLeft": "In {days} days",
  "caseDetail.addTask": "Add Task",
  "caseDetail.addNewTask": "Add New Task",
  "caseDetail.taskTitle": "Task Title",
  "caseDetail.taskDesc": "Task Description",
  "caseDetail.priority": "Priority",
  "caseDetail.priorityHigh": "Urgent",
  "caseDetail.priorityMedium": "Medium",
  "caseDetail.priorityLow": "Low",
  "caseDetail.pending": "Pending",
  "caseDetail.completed": "Completed",
  "caseDetail.noPendingTasks": "No pending tasks",
  "caseDetail.noCompletedTasks": "No completed tasks",
  "caseDetail.addDocument": "Add New Document",
  "caseDetail.docName": "Document Name",
  "caseDetail.docType": "Document Type",
  "caseDetail.noDocuments": "No documents",
  "caseDetail.addFinance": "Add",
  "caseDetail.addFinanceTitle": "Add Financial Transaction",
  "caseDetail.income": "Income",
  "caseDetail.expense": "Expense",
  "caseDetail.amount": "Amount",
  "caseDetail.description": "Description",
  "caseDetail.revenue": "Revenue",
  "caseDetail.expenses": "Expenses",
  "caseDetail.net": "Net",
  "caseDetail.noFinances": "No financial transactions",
  "caseDetail.notSpecified": "Not specified",
  "caseDetail.selectCourt": "Select Court",

  // Document types
  "docType.contract": "Contract",
  "docType.claim": "Claim",
  "docType.judgment": "Judgment",
  "docType.power": "Power of Attorney",
  "docType.evidence": "Evidence",
  "docType.correspondence": "Correspondence",
  "docType.other": "Other",

  // Case status
  "status.active": "Active",
  "status.pending": "Pending",
  "status.closed": "Closed",

  // Finances Tab
  "financesTab.newTransaction": "New Transaction",
  "financesTab.addTransaction": "Add Financial Transaction",
  "financesTab.selectCase": "Select Case",
  "financesTab.income": "Income",
  "financesTab.expense": "Expense",
  "financesTab.amount": "Amount",
  "financesTab.description": "Description",
  "financesTab.add": "Add",
  "financesTab.totalIncome": "Total Income",
  "financesTab.totalExpenses": "Total Expenses",
  "financesTab.netProfit": "Net Profit",
  "financesTab.allCases": "All Cases",
  "financesTab.date": "Date",
  "financesTab.case": "Case",
  "financesTab.type": "Type",
  "financesTab.noTransactions": "No financial transactions",
  "financesTab.noTransactionsHint": "Click \"New Transaction\" to add income or expense",
  "financesTab.unknown": "Unknown",
  "financesTab.currency": "KWD",

  // Time Tracking Tab
  "timeTracking.logHours": "Log Hours",
  "timeTracking.logNewHours": "Log New Work Hours",
  "timeTracking.selectCase": "Select Case *",
  "timeTracking.workDescription": "Work description",
  "timeTracking.hours": "Hours *",
  "timeTracking.hoursExample": "e.g. 2.5",
  "timeTracking.hourlyRate": "Hourly Rate (KWD) *",
  "timeTracking.rateExample": "e.g. 50",
  "timeTracking.calculatedTotal": "Calculated Total:",
  "timeTracking.register": "Log",
  "timeTracking.totalHours": "Total Hours",
  "timeTracking.totalFees": "Total Fees",
  "timeTracking.casesCount": "Cases Count",
  "timeTracking.feeSummary": "Fee Summary Per Case",
  "timeTracking.entry": "entry",
  "timeTracking.hour": "hour",
  "timeTracking.noEntries": "No time entries",
  "timeTracking.noEntriesHint": "Click \"Log Hours\" to add a new entry",
  "timeTracking.filterByCase": "Filter by case",
  "timeTracking.allCases": "All Cases",
  "timeTracking.editHours": "Edit Work Hours",
  "timeTracking.save": "Save Changes",

  // Case Documents Dialog
  "caseDocs.title": "Case Documents:",
  "caseDocs.docName": "Document Name",
  "caseDocs.docType": "Document Type",
  "caseDocs.docUrl": "Document Link (optional)",
  "caseDocs.add": "Add",
  "caseDocs.cancel": "Cancel",
  "caseDocs.addNew": "Add New Document",
  "caseDocs.noDocuments": "No documents attached",
  "caseDocs.noDocumentsHint": "Click \"Add New Document\" to attach documents",
  "caseDocs.errorNoName": "Please enter a document name",
  "caseDocs.added": "Document added successfully",
  "caseDocs.deleted": "Document deleted successfully",

  // Case Prediction Dialog
  "prediction.title": "Case Outcome Prediction",
  "prediction.caseNumber": "Case No:",
  "prediction.type": "Type:",
  "prediction.client": "Client:",
  "prediction.court": "Court:",
  "prediction.analyze": "Analyze & Predict Outcome",
  "prediction.analyzing": "Analyzing case...",
  "prediction.error": "Error during prediction",
  "prediction.rateLimited": "Rate limit exceeded, please try again later",
  "prediction.noBalance": "Please add AI account balance",

  // Case Summary Dialog
  "summary.title": "AI Case Summary",
  "summary.summarizing": "Summarizing...",
  "summary.copy": "Copy",
  "summary.copied": "Copied",
  "summary.regenerate": "Regenerate Summary",
  "summary.error": "Connection error",

  // Client Portal Dialog
  "clientPortal.info": "Information",
  "clientPortal.cases": "Cases",
  "clientPortal.documents": "Documents",
  "clientPortal.phone": "Phone Number",
  "clientPortal.email": "Email",
  "clientPortal.casesCount": "Cases Count",
  "clientPortal.notSpecified": "Not specified",
  "clientPortal.nextSession": "Next Session:",
  "clientPortal.caseNumber": "No:",
  "clientPortal.noCases": "No cases for this client",
  "clientPortal.noDocuments": "No documents for this client",
  "clientPortal.caseLabel": "Case:",

  // Consultation Lawyer Dialog
  "consult.title": "Consultation Lawyers",
  "consult.login": "Login",
  "consult.createProfile": "Create Profile Card",
  "consult.viewProfile": "Your Profile Card",
  "consult.alreadyLoggedIn": "You are already logged in as a consultation lawyer",
  "consult.viewMyProfile": "View My Profile Card",
  "consult.createMyProfile": "Create My Profile Card",
  "consult.chooseOption": "To create your profile card and display it to clients, choose one of the options:",
  "consult.loginTitle": "Login",
  "consult.loginDesc": "I have an account, I want to login and create my card",
  "consult.contactAdmin": "Contact Admin",
  "consult.contactAdminDesc": "Contact us via WhatsApp to get permission to join",
  "consult.back": "Back",
  "consult.email": "Email",
  "consult.password": "Password",
  "consult.emailRequired": "Email is required",
  "consult.emailInvalid": "Invalid email",
  "consult.emailNotAllowed": "This email is not authorized",
  "consult.passwordRequired": "Password is required",
  "consult.passwordShort": "Password must be at least 8 characters",
  "consult.logging": "Loading...",
  "consult.loginBtn": "Login",
  "consult.loginError": "Incorrect email or password",
  "consult.loginSuccess": "Logged in",
  "consult.welcomeBack": "Welcome back",
  "consult.canCreateProfile": "You can now create your profile card",
  "consult.addPhoto": "Add Photo",
  "consult.fullName": "Full Name",
  "consult.specialty": "Specialty",
  "consult.specialtyPlaceholder": "Criminal Lawyer / Legal Consultant",
  "consult.briefDescription": "Brief Description",
  "consult.descriptionPlaceholder": "Write a brief description of your experience...",
  "consult.whatsapp": "WhatsApp Number",
  "consult.saving": "Saving...",
  "consult.saveProfile": "Save Profile Card",
  "consult.saved": "Profile card saved successfully",
  "consult.viewAllLawyers": "View All Lawyers",
  "consult.contactViaWhatsapp": "Contact via WhatsApp",
  "consult.editProfile": "Edit Card",

  // Report page
  "report.printHeader": "Law Practice Management System",
  "report.printSubtitle": "Comprehensive report of all features and services",
  "report.printDate": "Report date:",
  "report.aboutDesc": "The Law Practice Management System is a comprehensive and advanced solution designed specifically for Arabic law firms. It provides tools for managing cases, clients, tasks, sessions, and files efficiently. Built with the latest technologies for fast performance, high security, and ease of use. Supports Arabic with an elegant and responsive interface across all devices.",
  "report.technicalFeatures": "Technical Features",
  "report.security": "Security",
  "report.securityDesc": "Secure local data storage",
  "report.speed": "Speed",
  "report.speedDesc": "Fast and smooth performance",
  "report.autoSave": "Auto Save",
  "report.autoSaveDesc": "Automatic data saving on any change",
  "report.analytics": "Analytics",
  "report.analyticsDesc": "Interactive charts for statistics",
  "report.modulesTitle": "Modules & Features",
  "report.interconnectedTitle": "Interconnected Systems",
  "report.interconnectedDesc": "Integrated parts that work together to provide a unified management experience",
  "report.summaryTitle": "System Summary",
  "report.mainModules": "Main Modules",
  "report.integratedFeatures": "Integrated Features",
  "report.arabicSupport": "Arabic Support",
  "report.alwaysAvailable": "Always Available",
  "report.aiIntegrated": "AI Integrated",
  "report.createdOn": "This report was created on",
  "report.allRightsReserved": "Law Practice Management System - All rights reserved",
  "report.taskDistribution": "Task Distribution & Hierarchical Management",
  "report.taskDistributionDesc": "The system relies on an integrated administrative structure linking general managers, team managers, and lawyers to ensure efficient work distribution and performance monitoring.",
  "report.generalManager": "General Manager",
  "report.teamManager": "Team Manager",
  "report.lawyer": "Lawyer",
  "report.caseLinking": "Linking Cases to Sessions, Tasks & Documents",
  "report.caseLinkingDesc": "Each case is connected to all its elements on a unified page, allowing the lawyer to manage the entire case from one place without switching between pages.",

  // Chart labels
  "chart.casesDistribution": "Cases Distribution",
  "chart.active": "Active",
  "chart.pending": "Pending",
  "chart.closed": "Closed",
  "chart.monthlyClients": "Monthly Clients",
  "chart.clients": "Clients",

  // Landing Page - Navbar
  "landing.nav.home": "Home",
  "landing.nav.login": "Login",
  "landing.nav.services": "Our Services",
 "landing.nav.contact": "Contact Us",
 "landing.nav.portal": "Get Started",
  "landing.nav.joinUs": "Join Us",
  "landing.nav.darkMode": "Enable Dark Mode",
  "landing.nav.lightMode": "Enable Light Mode",
  "landing.nav.joinTitle": "Join Us",
  "landing.nav.chooseAccount": "Choose your account type",
  "landing.nav.lawyer": "Lawyer",
  "landing.nav.lawyerDesc": "Law office management",
  "landing.nav.consultLawyer": "Consultation Lawyer",
  "landing.nav.consultLawyerDesc": "Provide online legal consultations",

  // Landing Page - Hero Carousel
  "landing.hero.slide1Title": "Manage Your Law Office Smartly",
  "landing.hero.slide1Subtitle": "An integrated system for managing cases, sessions, and clients",
  "landing.hero.slide2Title": "AI at the Service of\nLaw",
  "landing.hero.slide2Subtitle": "Analyze documents, contracts, and draft memos automatically",
  "landing.hero.slide3Title": "Advanced Legal Research",
  "landing.hero.slide3Subtitle": "Instant access to laws and judicial precedents",
  "landing.hero.prevSlide": "Previous Slide",
  "landing.hero.nextSlide": "Next Slide",

  // Landing Page - Auth Section
  "landing.auth.welcome": "Welcome to Legal AI",
  "landing.auth.chooseAccount": "Choose your account type to continue",
  "landing.auth.clients": "Clients",
  "landing.auth.clientsDesc": "I want to book a legal consultation",
  "landing.auth.lawyer": "Lawyer",
  "landing.auth.lawyerDesc": "I want to manage my office",
  "landing.auth.student": "Student",
  "landing.auth.studentDesc": "Legal educational research",
  "landing.auth.paidNotice": "✦ Law Office Management System — Paid Service ✦",
  "landing.auth.learnMore": "Learn about our services",
  "landing.auth.servicesTitle": "Legal AI Platform Services",
  "landing.auth.service1Title": "Smart Legal Assistant",
  "landing.auth.service1Desc": "AI-powered assistant to answer your legal queries instantly",
  "landing.auth.service2Title": "Case & File Management",
  "landing.auth.service2Desc": "Complete organization of all your cases and documents in one place",
  "landing.auth.service3Title": "Session & Appointment Tracking",
  "landing.auth.service3Desc": "Automatic session reminders and calendar management",
  "landing.auth.service4Title": "Financial Reports",
  "landing.auth.service4Desc": "Track revenue, expenses, and auto-generate invoices",
  "landing.auth.service5Title": "Team Management",
  "landing.auth.service5Desc": "Distribute tasks and monitor team performance",
  "landing.auth.service6Title": "Contract & Document Analysis",
  "landing.auth.service6Desc": "Smart contract analysis and automatic clause extraction",

  // Landing Page - Login Form
  "landing.login.lawyerAccount": "Lawyer Account",
  "landing.login.consultAccount": "Consultation Lawyer Account",
  "landing.login.clientAccount": "Client Account",
  "landing.login.title": "Login",
  "landing.login.name": "Name",
  "landing.login.email": "Email",
  "landing.login.password": "Password",
  "landing.login.rememberMe": "Remember me",
  "landing.login.forgotPassword": "Forgot password?",
  "landing.login.submit": "Login",
  "landing.login.processing": "Processing...",
  "landing.login.changeType": "​",
  "landing.login.paidNotice": "Office management is a paid service",
  "landing.login.supportInquiry": "Inquiry",
  "landing.login.techSupport": "Technical Support",
  "landing.login.supportTitle": "Contact & Support",
  "landing.login.whatsappInquiry": "WhatsApp Inquiry",
  "landing.login.whatsappContact": "WhatsApp Contact",
  "landing.login.techSupport1": "Tech Support 1",
  "landing.login.techSupport2": "Tech Support 2",

  // Landing Page - Validation
  "landing.validation.emailRequired": "Email is required",
  "landing.validation.emailInvalid": "Email must contain @",
  "landing.validation.emailFormat": "Invalid email format",
  "landing.validation.passwordRequired": "Password is required",
  "landing.validation.passwordShort": "Password must be at least 8 characters",
  "landing.validation.dataError": "Data Error",
  "landing.validation.unauthorized": "Unauthorized",
  "landing.validation.consultUnauthorized": "This email is not authorized for consultation lawyer access",
  "landing.validation.lawyerUnauthorized": "This email is not authorized for lawyer access. Use your lawyer email",
  "landing.validation.consultRedirect": "Consultation lawyers login via 'Login' → Consultation Lawyer",
  "landing.validation.loginError": "Login Error",
  "landing.validation.wrongCredentials": "Incorrect email or password",
  "landing.validation.accountExpired": "Account Expired",
  "landing.validation.accountExpiredDesc": "Your account has expired. Contact admin to renew.",
  "landing.validation.loginSuccess": "Login Successful",
  "landing.validation.welcomeLawyer": "Welcome to the office management system",
  "landing.validation.welcomeConsult": "Welcome to the consultation panel",
  "landing.validation.welcomeClient": "Welcome",
  "landing.validation.unexpectedError": "Error",
  "landing.validation.tryAgain": "An unexpected error occurred, please try again",

  // Landing Page - Services Section
  "landing.services.aiAssistant": "Smart Legal Assistant",
  "landing.services.aiAssistantDesc": "AI to answer your legal queries instantly",
  "landing.services.caseManagement": "Case Management",
  "landing.services.caseManagementDesc": "Track cases, sessions, and appointments organized",
  "landing.services.contractAnalysis": "Contract Analysis",
  "landing.services.contractAnalysisDesc": "Analyze documents and extract key clauses automatically",
  "landing.services.legalMemos": "Legal Memos",
  "landing.services.legalMemosDesc": "Create professional memos with AI",
  "landing.services.financialReports": "Financial Reports",
  "landing.services.financialReportsDesc": "Track revenue, expenses, and issue invoices",
  "landing.services.teamManagement": "Team Management",
  "landing.services.teamManagementDesc": "Distribute tasks and monitor team performance",

  // Landing Page - Footer
  "landing.footer.brandDesc": "A smart legal platform combining AI and law office management for a comprehensive professional experience",
  "landing.footer.services": "Our Services",
  "landing.footer.quickLinks": "Quick Links",
  "landing.footer.contactUs": "Contact Us",
  "landing.footer.home": "Home",
  "landing.footer.features": "Features",
  "landing.footer.login": "Login",
  "landing.footer.whatsappInquiry": "WhatsApp Inquiry",
  "landing.footer.techSupport": "Technical Support",
  "landing.footer.callUs": "Call Us",
  "landing.footer.copyright": "All rights reserved.",

  // Client Home Page
  "client.nav.services": "Services",
  "client.nav.consultations": "Consultations",
  "client.nav.testimonials": "Testimonials",
  "client.nav.logout": "Logout",
  "client.services.title": "Our Legal Services",
  "client.services.subtitle": "We offer you the best legal services with a team of specialized lawyers",
  "client.bookConsultation": "Book Your Consultation Now",
  "client.onlineConsultation": "Online Consultation",
  "client.onlineDesc": "Via video call",
  "client.onlineDuration": "Duration: 30-60 minutes",
  "client.onlinePlatform": "Via Zoom or Google Meet",
  "client.offlineConsultation": "In-Person Consultation",
  "client.offlineDesc": "At the law office",
  "client.offlineDuration": "Duration: 45-90 minutes",
  "client.offlineLocation": "At our main office",
  "client.selected": "Selected",
  "client.whyChooseUs": "Why Choose Us",
  "client.confidential": "Full Confidentiality",
  "client.confidentialDesc": "Protecting your data with the highest standards",
  "client.fastResponse": "Fast Response",
  "client.fastResponseDesc": "Reply within 24 hours",
  "client.experience": "Extensive Experience",
  "client.experienceDesc": "Specialized lawyers",
  "client.followUp": "Continuous Follow-up",
  "client.followUpDesc": "Step by step until the result",
  "client.availableLawyers": "Available Lawyers",
  "client.contactWhatsapp": "Contact via WhatsApp",
  "client.whatsapp": "WhatsApp",
  "client.bookAppointment": "Book Appointment",
  "client.bookAppointmentTitle": "Book Appointment",
  "client.scheduleAppointment": "Book an appointment with the right lawyer",
  "client.feeCalculator": "Court Fee Calculator",
  "client.feeCalculatorDesc": "Calculate your case fees accurately and quickly",
  "client.legalTemplates": "Ready Legal Templates",
  "client.legalTemplatesDesc": "Download contract, complaint, and memo templates",
  "client.caseTracker": "Case Tracker",
  "client.caseTrackerDesc": "Track your case status directly",
  "client.whatsappFormTitle": "Contact via WhatsApp",
  "client.fullName": "Full Name",
  "client.enterName": "Enter your name",
  "client.problemDesc": "Problem Description",
  "client.problemPlaceholder": "Briefly describe your legal problem...",
  "client.sendWhatsapp": "Send via WhatsApp",
  "client.caseTrackerTitle": "Track Case Status",
  "client.caseTrackerHint": "Enter your name and phone number registered with the lawyer",
  "client.phonePlaceholder": "Phone number (e.g. +201004298934)",
  "client.searchCases": "Search my cases",
  "client.searching": "Searching...",
  "client.noCasesFound": "No cases found matching this data",
  "client.caseNumber": "Case Number:",
  "client.caseType": "Type:",
  "client.court": "Court:",
  "client.nextSession": "Next Session:",
  "client.statusActive": "Active",
  "client.statusPending": "Pending",
  "client.statusClosed": "Closed",
  "client.feeCalcTitle": "Court Fee Calculator",
  "client.caseTypeLabel": "Case Type",
  "client.selectCaseType": "Select case type",
  "client.civil": "Civil",
  "client.commercial": "Commercial",
  "client.family": "Family/Personal Status",
  "client.criminal": "Criminal",
  "client.labor": "Labor",
  "client.claimAmount": "Claim Amount (EGP)",
  "client.enterClaimAmount": "Enter claim amount",
  "client.calculateFees": "Calculate Fees",
  "client.feeEstimate": "Court Fee Estimate",
  "client.registrationFee": "Registration Fee",
  "client.serviceFee": "Service Fee",
  "client.totalFee": "Total",
  "client.feeDisclaimer": "* This is an approximate estimate, actual fees may differ",
  "client.legalTemplatesTitle": "Ready Legal Templates",
  "client.templatesHint": "Select the required template to contact and request a copy",
  "client.satisfiedClients": "Satisfied Clients",
  "client.successfulCases": "Successful Cases",
  "client.yearsExperience": "Years of Experience",
  "client.successRate": "Success Rate",
  "client.clientReviews": "Client Reviews",
  "client.whatClientsSay": "What our clients say about our services",
  "client.ctaTitle": "Have a legal question?",
  "client.ctaDesc": "Our team of specialized lawyers is ready to help. Book your consultation now and get the legal support you need.",
  "client.startNow": "Start Now",
  "client.needHelp": "Need help? Contact us",
  "client.footerBrandDesc": "A smart legal platform offering comprehensive consulting services with the latest AI technologies.",
  "client.footerQuickLinks": "Quick Links",
  "client.bookConsultationLink": "Book Consultation",
  "client.feeCalcLink": "Fee Calculator",
  "client.templatesLink": "Legal Templates",
  "client.caseTrackerLink": "Case Tracker",
  "client.footerServices": "Our Services",
  "client.legalConsultations": "Legal Consultations",
  "client.civilCommercial": "Civil & Commercial Cases",
  "client.familyPersonal": "Family & Personal Status Cases",
  "client.contractsDocs": "Contracts & Documentation",
  "client.footerContact": "Contact Us",
  "client.location": "Cairo, Egypt",
  "client.allRights": "All rights reserved",

  // Legal Templates
  "template.rentalContract": "Rental Contract",
  "template.rentalContractDesc": "Comprehensive residential/commercial rental contract template",
  "template.saleContract": "Property Sale Contract",
  "template.saleContractDesc": "Preliminary sale contract template with all guarantees",
  "template.criminalComplaint": "Criminal Complaint",
  "template.criminalComplaintDesc": "Complaint/report template for the public prosecution",
  "template.officialNotice": "Official Notice",
  "template.officialNoticeDesc": "Notice via bailiff template",
  "template.specialPOA": "Special Power of Attorney",
  "template.specialPOADesc": "Special litigation power of attorney template",
  "template.employmentContract": "Employment Contract",
  "template.employmentContractDesc": "Fixed/unfixed term employment contract template",
  "template.defenseMemo": "Defense Memo",
  "template.defenseMemoDesc": "Civil case defense memo template",
  "template.appealRequest": "Appeal Request",
  "template.appealRequestDesc": "Appeal petition template",
  "template.contracts": "Contracts",
  "template.complaints": "Complaints",
  "template.notices": "Notices",
  "template.poa": "POA",
  "template.memos": "Memos",
  "template.appeals": "Appeals",

  // Student Page
  "student.legalLibrary": "Legal Library",
  "student.forStudents": "For law students and researchers",
  "student.switchMode": "Toggle mode",
  "student.back": "Back",
  "student.educationalPlatform": "Educational Platform for Students",
  "student.heroTitle1": "Start Your Journey in the World of",
  "student.heroTitle2": "Law and Legal Practice",
  "student.heroDesc": "A comprehensive educational platform offering research, lectures, and resources to develop your legal skills and achieve academic excellence",
  "student.searchPlaceholder": "Search for research, lectures, terms...",
  "student.filter": "Filter",
  "student.all": "All",
  "student.civilLaw": "Civil Law",
  "student.criminalLaw": "Criminal Law",
  "student.commercialLaw": "Commercial Law",
  "student.laborLaw": "Labor Law",
  "student.familyLaw": "Family Law",
  "student.research": "Research",
  "student.lectures": "Lectures",
  "student.resources": "Resources",
  "student.researchTopics": "Research & Topics",
  "student.researchCount": "research",
  "student.readResearch": "Read Research",
  "student.noResearch": "No research available",
  "student.noResearchDesc": "Legal research and topics will be added soon. Stay tuned for the latest educational content.",
  "student.videoLectures": "Video Lectures",
  "student.lectureCount": "lecture",
  "student.closeVideo": "Close Video",
  "student.watchLecture": "Watch Lecture",
  "student.noLectures": "No lectures available",
  "student.noLecturesDesc": "Video lectures will be added soon. Follow the platform for the latest lessons.",
  "student.legalSources": "Legal Sources & References",
  "student.sourceCount": "source",
  "student.visitSite": "Visit Website",
  "student.noSources": "No sources available",
  "student.noSourcesDesc": "Legal sources and references will be added soon.",
  "student.goldenTips": "Golden Tips & Guidelines",
  "student.goldenTipsDesc": "Gain practical skills for your legal career",
  "student.readMore": "Read More",
  "student.noTips": "No tips available",
  "student.noTipsDesc": "Legal tips and guidelines will be added soon to help you in your academic journey.",
  "student.postgrad": "Master's & PhD Preparation",
  "student.postgradDesc": "Tools and resources to help you in your advanced academic journey",
  "student.researchPlan": "Research Plan Preparation",
  "student.researchPlanDesc": "Learn how to write a strong academic research plan including methodology and hypotheses",
  "student.researchPlanItem1": "Choosing a topic and defining the problem",
  "student.researchPlanItem2": "Formulating hypotheses and research questions",
  "student.researchPlanItem3": "Scientific methodology and research tools",
  "student.researchPlanItem4": "Theoretical framework and previous studies",
  "student.thesisWriting": "Academic Thesis Writing",
  "student.thesisWritingDesc": "Comprehensive guide for writing master's thesis or doctoral dissertation to academic standards",
  "student.thesisItem1": "Structuring the thesis and its chapters",
  "student.thesisItem2": "Documentation and references per APA / Chicago",
  "student.thesisItem3": "Data analysis and presenting results",
  "student.thesisItem4": "Discussion and thesis defense",
  "student.legalSourceSearch": "Searching Legal Sources",
  "student.legalSourceSearchDesc": "Learn methods of searching in specialized legal databases and libraries",
  "student.sourceItem1": "Using legal databases",
  "student.sourceItem2": "Searching rulings and legislation",
  "student.sourceItem3": "Analyzing judicial jurisprudence",
  "student.sourceItem4": "Comparing legal systems",
  "student.publishing": "Publishing in Academic Journals",
  "student.publishingDesc": "Steps and guidelines for publishing your research in peer-reviewed journals",
  "student.publishItem1": "Choosing the right journal for publication",
  "student.publishItem2": "Preparing the research paper for publication",
  "student.publishItem3": "Handling reviewer feedback",
  "student.publishItem4": "Quality and originality standards",
  "student.researchMethods": "Legal Research Methods",
  "student.researchMethodsDesc": "Overview of scientific methods used in advanced legal studies",
  "student.methodItem1": "Descriptive and analytical method",
  "student.methodItem2": "Comparative method in law",
  "student.methodItem3": "Historical and inductive method",
  "student.methodItem4": "Case study as a research tool",
  "student.supervision": "Supervision & Defense",
  "student.supervisionDesc": "Tips for dealing with academic supervisors and preparing for thesis defense",
  "student.supervisionItem1": "Choosing the right supervisor",
  "student.supervisionItem2": "Effective communication with supervisor",
  "student.supervisionItem3": "Preparing the defense presentation",
  "student.supervisionItem4": "Answering defense committee questions",
  "student.footerRights": "All rights reserved © 2026 - Educational platform for law students and researchers",
  "student.content": "Content",
  "student.keyPoints": "Key Points",
  "student.close": "Close",
  "student.saveForLater": "Save for Later",
  "student.details": "Details",
  "student.benefits": "Benefits",
  "student.beginner": "Beginner",
  "student.intermediate": "Intermediate",
  "student.advanced": "Advanced",
  "student.live": "Live",
  "student.website": "Website",
  "student.library": "Library",
  "student.database": "Database",
  "student.journal": "Journal",

  // Testimonials
  "testimonial.name1": "Ahmed Mohamed",
  "testimonial.role1": "Businessman",
  "testimonial.content1": "I dealt with the firm on a complex commercial case and the result was excellent. I highly recommend them.",
  "testimonial.name2": "Sara Al-Ali",
  "testimonial.role2": "Company Manager",
  "testimonial.content2": "Professional service and continuous follow-up. Thanks to the team for their efforts.",
  "testimonial.name3": "Khaled Al-Saeed",
  "testimonial.role3": "Investor",
  "testimonial.content3": "The only firm I trust with all my legal matters. High expertise and competence.",
};
